export default {
  sku: {
    id: 'bo_sellers-orders-components-orders_table-sku',
    defaultMessage: 'SKU',
  },
  quantity: {
    id: 'bo_sellers-orders-components-orders_table-quantity',
    defaultMessage: 'Quantity',
  },
} as const
